import React from 'react'

const ServiceLists = ({themeMode, serviceLists}) => {

    // const LineLink = true
    const LineLink = false

    function BuyCurrencyClicked(){
  
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/sell-or-buy-crypto");
      } else {
         window.location.replace("http://localhost:3000/sell-or-buy-crypto");
      }
    }
  
    function SellCurrencyClicked(){
  
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/sell-or-buy-crypto");
      } else {
         window.location.replace("http://localhost:3000/sell-or-buy-crypto");
      }
    }

  return (
    <div className={`${themeMode === "true" ? "home-crypto-section home-crypto-section-t p-4 justify-content-center" : "home-crypto-section p-4 justify-content-center"}`}>
      {
        serviceLists.length > 0 ?
          serviceLists.map((item, index) => (
            <div key={index} className='m-2'>
              {
                item.serviceSymbol === 'ntr' || item.serviceSymbol === 'PAYEER' ? null :
                  <div className='nkab-items-name'>
                    <div className='new-view d-flex justify-content-between'>
                      <div style={{ padding: '10px 0 0 7px' }}>
                        <img className="images-drapeau" src={`${item.serviceImageLink}`} alt={item.serviceName} />
                      </div>
                      <div className='d-flex justify-content-between p-2'>
                        <span className='mr-3 pointer home-buy-btn' style={{ color: ' #37ff62' }} onClick={BuyCurrencyClicked}>Acheter</span>
                        <span className='pointer home-sell-btn' style={{ color: ' #ff8686' }} onClick={SellCurrencyClicked}>Vendre</span>
                      </div>
                    </div>
                    <div style={{ padding: '11px 0 0 0' }}> <span className='home-crypto-title bolder uppercase'>{item.serviceName}</span></div>
                  </div>
                }
            </div>
          )):null
      }
    </div>
  )
}

export default ServiceLists